import React from "react";
import * as R from "ramda";
import { getSettings, getValue } from "../../utils";

import { Div, HalfSizeDotIcon } from "components/Base";

const TEXT_STYLES = { fontSize: "12px", fontWeight: 600, color: "black" };

const CONTAINER_STYLES = {
  cursor: "default",
  padding: "4px 8px",
  borderRadius: "4px"
};

const PARENT_CONTAINER_STYLES = {
  width: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "flex",
  alignItems: "center"
};

const StatusWithDot = props => {
  const { statusColors } = getSettings(props);
  const value = getValue(props);
  return (
    <Div style={PARENT_CONTAINER_STYLES}>
      {typeof value === "string" ? (
        <>
          <HalfSizeDotIcon
            color={R.pathOr("#f6f0ff", [value, "light"], statusColors)}
          />
          <Div
            style={{
              color: R.pathOr("#adadad", [value, "dark"], statusColors),
              fontWeight: 600
            }}
          >
            {value}
          </Div>
        </>
      ) : (
        <Div
          style={{
            ...CONTAINER_STYLES,
            background: statusColors[value.status.toLowerCase()]
          }}
        >
          <span style={TEXT_STYLES}>{value.status}</span>
        </Div>
      )}
    </Div>
  );
};

export default StatusWithDot;
